// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"26":"f41c0ecf","123":"8df95163","522":"27b1b3e4","553":"54db6064","561":"67c50a76","848":"98d79aaf","980":"83ba2197"}[chunkId] + ".css";
};